import * as React from 'react';
import { ERROR_CODES } from 'ts/passwordless-login/components/pages/error/ErrorCodes';
import { navigateToErrorPageFromForgotEmail } from 'ts/passwordless-login/components/pages/error/ErrorNavigation';
import { Content } from 'ts/passwordless-login/components/pages/find-email/Interfaces';
import { findAccountByCriteria } from 'ts/services/find-account/FindAccountService';
import { DOB, USERNAME, LAST_NAME, POSTCODE } from '../../../../constants/UrlParams';
import { ROUTES } from '../../../../Routes';
import { FindEmailPage } from '../../pages/find-email/FindEmailPage';
import { getForgotEmailUrl } from 'ts/config/ConfigService';
import { RouteComponentProps } from 'react-router-dom';

const nextAction = (history: any) => (email: string) => {
  return history.push({
    pathname: ROUTES.FORGOT_USERNAME_ACCOUNT_FOUND,
    search: `?${USERNAME}=${email}`,
  });
};

const conflictAccountAction = (history: any) => (
  lastName: string,
  dob: string,
  postcode: string,
) => {
  return history.push({
    pathname: ROUTES.FORGOT_USERNAME_ACCOUNT_NUMBER,
    search: `?${LAST_NAME}=${lastName}&${DOB}=${dob}&${POSTCODE}=${postcode}`,
  });
};

const errorPageAction = (history: any) => () => {
  navigateToErrorPageFromForgotEmail(ERROR_CODES.FORGOT_EMAIL_3_POINT_CHECK, history);
};

const findAccountAction = (lastName: string, dob: string, postcode: string) => {
  return findAccountByCriteria(lastName, dob, postcode);
};

const ForgotUsernameCustomerLookupPage: React.FC<RouteComponentProps> = ({ history, location }) => {
  const content: Content = {
    analytics: {
      navigation: {
        friendlyUri: 'originenergy:my-account:auth:forgot-email-verify',
      },
      taskType: 'forgot-email',
      errorForm: {
        formName: 'my-account:forgot-email',
        errorMessage: 'forgot-email:account-not-found',
        errorCode: 'account-not-found',
      },
    },
    copy: {
      headingText: "Let's find your email",
      infoText: `Let's get some extra details to verify who you are. If you're a business customer, find your [email here](#${ROUTES.FORGOT_USERNAME_FIND_BUSINESS_CUSTOMER}).`,
      alertBoxText:
        "We're having trouble finding you in our system. Please [get in touch](LIVECHAT), one of our agents can help you out.",
    },
  };
  return (
    <FindEmailPage
      findAccountAction={findAccountAction}
      errorPageAction={errorPageAction(history)}
      content={content}
      history={history}
      nextAction={nextAction(history)}
      conflictAccountAction={conflictAccountAction(history)}
    />
  );
};

export { ForgotUsernameCustomerLookupPage };
